<p-dialog
    header="{{ 'page.commissions.synthese-jure.modals.detail' | translate: {jure: jure?.nom} }} " [modal]="true"
    [closable]="true"
    [(visible)]="visible"
    appendTo="body"
    [style]="{ width: '70rem', height: '45rem' }">

    @if (detailJures.length > 0) {
        <p-table [value]="detailJures" [scrollable]="true" scrollHeight="flex">
            <ng-template pTemplate="header">
                <tr>
                    @for (col of columns; track col) {
                        <th scope="col">{{ col.label | translate }}</th>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-jure>
                <tr>
                    <td>{{ jure.numeroCommission }}</td>
                    <td>{{ jure.dateCommission | date:'shortDate' }}</td>
                    <td>{{ jure.statutJure?.libelle }}</td>
                    <td class="small">
                        @for (college of jure.colleges; track $index) {
                            <span>{{ college.libelle }}<br></span>
                        }
                    </td>
                    <td class="small">
                        @for (cahier of jure.cahiers; track $index) {
                            <span>{{ cahier.libelle }}<br></span>
                        }
                    </td>
                </tr>
            </ng-template>
        </p-table>
    }
</p-dialog>
